import styled from 'styled-components';
import { FormikProps } from 'formik';
import { JoinFormType, PackagePrices } from 'types/join';
import { YourPlan } from './your-plan';
import { OrderSummary } from './order-summary';

const PlanBox = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.siteCardBackground};
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  border-radius: 16px;
  padding: 24px 22px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 999px) {
    display: block;
    padding: 20px 16px;
  }
`;

const StickyBox = styled.div`
  width: 100%;

  @media (max-width: 999px) {
    width: 100%;
    position: relative;
  }
`;

interface YourPlanContainerProps {
  setSelectedAddons: (addons: Array<PackagePrices | undefined>) => void;
  setSelectedPlan: (plan: PackagePrices | undefined) => void;
  selectedPlan: PackagePrices | undefined;
  selectedBilledOption: string;
  setSelctedBilledOption: (option: string) => void;
  isYourPlanActive: boolean;
  setIsYourPlanActive: (active: boolean) => void;
  setNumConfirmClicked: (num: number) => void;
  form: FormikProps<JoinFormType>;
  isPriceList: boolean;
  selectedAddons: Array<PackagePrices | undefined>;
  onPromoCodeApplied: (promoCodeId: string) => void;
  setFinalTotalPrice: (total: number) => void;
  finalTotalPrice: number;
}

export const YourPlanContainer = ({
  setSelectedAddons,
  setSelectedPlan,
  selectedPlan,
  selectedBilledOption,
  setSelctedBilledOption,
  isYourPlanActive,
  setIsYourPlanActive,
  setNumConfirmClicked,
  form,
  isPriceList,
  selectedAddons,
  onPromoCodeApplied,
  setFinalTotalPrice,
  finalTotalPrice
}: YourPlanContainerProps) => (
  <PlanBox>
    <StickyBox>
      <YourPlan
        setSelectedAddons={setSelectedAddons}
        savedSelectedAddons={selectedAddons}
        setSelectedPlan={setSelectedPlan}
        selectedPlan={selectedPlan}
        selectedBilledOption={selectedBilledOption}
        setSelctedBilledOption={setSelctedBilledOption}
        isActive={isYourPlanActive}
        setIsActive={setIsYourPlanActive}
        setNumConfirmClicked={setNumConfirmClicked}
        form={form}
        isPriceList={isPriceList}
      />
      <OrderSummary
        selectedPlan={selectedPlan}
        selectedAddons={selectedAddons}
        onPromoCodeApplied={onPromoCodeApplied}
        userCountry={form.values.companyCountry ?? ''}
        setFinalTotalPrice={setFinalTotalPrice}
        finalTotalPrice={finalTotalPrice}
        isActive={isYourPlanActive}
      />
    </StickyBox>
  </PlanBox>
);
